// Versão translúcida de uma cor hex (#rrggbb). No tema escuro os realces usam o tom claro
// da escala com pouca opacidade, para não virarem blocos saturados sobre o fundo.
export function tint(hex, alpha) {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}
